module.exports = __webpack_public_path__ + "static/media/hillary.df9f0f88.jpg";